import styled from 'styled-components';
import { Tag } from 'antd';

export const StyledTag = styled(Tag)`
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-right: 3px;
  &.ant-tag-has-color, .ant-tag-close-icon {
    color: ${({ textColor }) => textColor || '#000'} !important;
    border-color: #000 !important;
  }
`;